// Dentreat.uk — Orka Chat'i menü açıkken otomatik gizle
document.addEventListener("DOMContentLoaded", () => {
  const menuDrawer = document.getElementById("Details-menu-drawer");
  if (!menuDrawer) return;

  // Orka container'ı izlemek için bekleme fonksiyonu
  const waitForOrka = (callback) => {
    const orka = document.querySelector(".orka-container");
    if (orka) {
      callback(orka);
    } else {
      // henüz yüklenmediyse tekrar dene
      setTimeout(() => waitForOrka(callback), 500);
    }
  };

  waitForOrka((orka) => {
    const toggleOrka = () => {
      if (menuDrawer.hasAttribute("open")) {
        orka.style.opacity = "0";
        orka.style.pointerEvents = "none";
      } else {
        orka.style.opacity = "1";
        orka.style.pointerEvents = "auto";
      }
    };

    // İlk durumu kontrol et
    toggleOrka();

    // Menü açılıp kapanınca çalışsın
    menuDrawer.addEventListener("toggle", toggleOrka);

    // Eğer Orka yeniden yüklenirse (bazı sayfalarda script yeniden çalışıyor)
    const mo = new MutationObserver(() => {
      const newOrka = document.querySelector(".orka-container");
      if (newOrka && newOrka !== orka) {
        newOrka.style.opacity = menuDrawer.hasAttribute("open") ? "0" : "1";
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  });
});

// Dentreat.uk — Orka chat iframe'ine erişilebilir title ekle (PSI frame-title, session-99)
// Orka kendi script'i iframe'i src/id değişse bile yeniden yaratabildiği için
// MutationObserver ile sürekli izlenir; her yeni #orka-iframe'e title yeniden yazılır.
document.addEventListener("DOMContentLoaded", () => {
  const ORKA_IFRAME_TITLE = "Dentreat Live Chat";

  const setOrkaIframeTitle = (iframe) => {
    if (iframe && iframe.getAttribute("title") !== ORKA_IFRAME_TITLE) {
      iframe.setAttribute("title", ORKA_IFRAME_TITLE);
    }
  };

  // Sayfada zaten varsa hemen uygula
  document.querySelectorAll("#orka-iframe, iframe[src*='widget.orka.chat']").forEach(setOrkaIframeTitle);

  // Orka gecikmeli inject ediyor — DOM'a eklendiğinde de yakala
  const orkaTitleObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches && (node.matches("#orka-iframe") || node.matches("iframe[src*='widget.orka.chat']"))) {
          setOrkaIframeTitle(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll("#orka-iframe, iframe[src*='widget.orka.chat']").forEach(setOrkaIframeTitle);
        }
      });
    });
  });
  orkaTitleObserver.observe(document.body, { childList: true, subtree: true });
});
